/**
 * Internal dependencies
 */
import vd from 'lib/vd';
import * as actions from 'state/action-types';
import receiveDashboardLayouts from './receive-dashboard-layouts';

export default () => (dispatch) => {
	dispatch({
		type: actions.DASHBOARD_LAYOUTS_REQUEST,
	});
	return vd
		.layout()
		.listAll()
		.then((dashboardLayouts) => {
			dispatch({
				type: actions.DASHBOARD_LAYOUTS_REQUEST_SUCCESS,
			});
			dispatch(receiveDashboardLayouts(dashboardLayouts));
			return dashboardLayouts;
		});
};